import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type PaginatedResponse } from './types'
import { type CensusStatus, type ProspectEmployeeCensus } from '../prospects/types'

export function useGetCensuses ({
  prospectId,
  pagination,
  statusFilter,
}: {
  prospectId: string;
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
  statusFilter?: CensusStatus;
}) {
  return useQuery<PaginatedResponse<ProspectEmployeeCensus>, GrapeAPIErrorType>(
    {
      queryKey: ['prospect', prospectId, 'census', statusFilter],
      queryFn: async () => {
        let queryParams: Record<string, any> = {
          'page[number]': pagination.pageIndex.toString(),
          'page[size]': pagination.pageSize.toString(),
        }
        if (statusFilter) {
          queryParams = { ...queryParams, 'filter[status]': statusFilter }
        }
        const queryString = new URLSearchParams(queryParams).toString()
        const url = `/api/web/quoting/prospects/${prospectId}/census?${queryString}`
        const response = await fetchWithHeaders(url)
        if (!response.ok) {
          const errorJson = await response.json()
          throw GrapeAPIError({
            status: response.status,
            message: errorJson.message,
            errors: errorJson.errors,
          })
        }
        return response.json()
      },
      retry: false,
    }
  )
}
